<!--
 * @Author: shijian.chen shijian.chen@qunar.com
 * @Date: 2022-07-30 17:36:37
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @LastEditTime: 2023-05-05 14:05:19
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/lianhuaqingwen2212/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="main" class="lianhuaqingwen">
    <div class="top"></div>
    <div class="box1">
      <div class="content">
        <div class="swipe">
          <div class="swipe-wrapper swiper-container">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, index) in imgList"
                :key="index"
              >
                <div class="img-box">
                  <div class="img">
                    <img :src="item" alt="" />
                  </div>
                </div>
                <a
                  v-for="(item, ind) in linkList"
                  :key="ind"
                  v-show="index == ind"
                  v-maidian="'link_'+ind"
                  @click="
                    jumpLink(item.link,
                    )
                  "
                  class="btn1"
                >
                  <span
                    >{{item.text}}<img
                      src="https://source.qunarzz.com/site/images/wns/20230206-shijianchen-lian-arr.png"
                      class="arr"
                      alt=""
                  /></span>
                </a>
              </div>
            </div>
            <!-- <div class="swiper-pagination"></div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="box2">
      <div class="content">
        <div class="swipe-wrapper">
          <mt-swipe :auto="0" ref="swipeWrapper">
            <mt-swipe-item v-for="(item, index) in voteList" :key="index">
              <div class="img-box">
                <video-comp
                  :src="item.video"
                  :poster="item.poster"
                ></video-comp>
                <div @click="jumpTo(item)" class="note">
                  <div class="note-lf">
                    <img :src="item.note.img" alt="" />
                  </div>
                  <div class="note-rt">
                    <div class="note-nick">
                      <img :src="item.note.logo" class="logo" />{{
                        item.note.nickName
                      }}
                    </div>
                    <div class="note-cont">
                      {{ item.note.content }}
                    </div>
                  </div>
                </div>
              </div>
            </mt-swipe-item>
          </mt-swipe>
          <div class="prev-button btn" @click="prev"></div>
          <div class="next-button btn" @click="next"></div>
        </div>
      </div>
    </div>

    <div class="box3">
      <div class="content">
        <!-- <div class="text">
          <div class="tp">
            <div v-if="days > 0" class="text2">
              <span>距</span><span>离</span><span>春</span><span>节</span
              ><span>购</span><span>票</span><span>还</span><span>有</span>
            </div>
            <div v-else>出行必备&nbsp;&nbsp;&nbsp;&nbsp;连花清瘟</div>
          </div>
          <div v-if="days > 0" class="btm">
            <div class="text2">
              倒计时<span class="str">{{ nums[0] }}</span
              ><span class="str">{{ nums[1] }}</span
              >天
            </div>
          </div>
        </div> -->
        <div class="boxBoth">
          <img
            @click="jumpFlight"
            src="https://source.qunarzz.com/site/images/wns/20221203-shijianchen-ticket-1.png"
            alt=""
          />
          <img
            @click="jumpTrain"
            src="https://source.qunarzz.com/site/images/wns/20221203-shijianchen-ticket-2.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="box6">
      <div class="content">
        <img
          src="https://source.qunarzz.com/site/images/wns/20221203-shijianchen-haiwang.png"
          alt=""
        />
        <div class="box6-txt">
          海王星辰健康药房，成立于1995年，3800多家门店星罗棋布在全国70多个沿海及经济发达一线城市；<br />
          7000多名药师，17000多名健康顾问，为顾客提供专业的药事服务，并通过企业微信提供1对1的购药服务和用药指导；<br />
          微信小程序“星辰药急送”、海王星辰直播间、“海王星辰”APP，让顾客足不出户，也可以便捷获取健康资讯和优质产品。
        </div>
      </div>
    </div>
    <div class="box7">
      <div class="content">
        <video-comp
          :src="'https://source.qunarzz.com/site/images/wns/20221203-shijianchen-lianhua-video.mp4'"
          :poster="'https://source.qunarzz.com/site/images/wns/20221204-shijianchen-poster.png'"
        ></video-comp>
      </div>
    </div>
    <div class="box4">
      <div class="content">
        <a
          href="https://touch.dujia.qunar.com/p/item/2221465247?tuId=PID2221465247G2659641365&tm=l01_all_search_newano&ti=3&qssrc=eyJ0cyI6IjE2NzAxNDY1NzQ0NzMiLCJzcmMiOiJhbGwuZW52YW5vIiwiYWN0Ijoic2VhcmNoIiwicmFuZG9tIjoiMjQzMzYifQ==&djtf=dj_list_A-B-C_3-sbj_%E4%BF%9D%E5%A7%86%E8%BD%A628_newano,dj_list_A-B-C_9-tts_2+1%E5%A4%B4%E7%AD%89%E8%88%B128_newano,dj_list_A-B-C_9-tts_%E9%AB%98%E7%AB%AF%E6%B8%B828_newano,dj_list_A-B-C_9-tts_%E5%A4%B4%E7%AD%89%E8%88%B1%E5%A4%A7%E5%B7%B428_newano&ts=1670146578416_495&tp="
          class="line"
        >
          <div class="line-lf">
            <img
              src="https://source.qunarzz.com/site/images/wns/20221203-shijianchen-line1.png"
              alt=""
            />
          </div>
          <div class="line-rt">
            <div class="line-tit text-overflow">
              成都+九寨沟+黄龙+熊猫乐园+都江堰+峨眉山+乐山大佛6天5晚|真纯玩0自费+住高端酒店+免费接送机
            </div>
            <div class="line-btm">
              <span class="price">2144<i>起/人</i></span>
              <span class="go">马上出发</span>
            </div>
          </div>
        </a>
        <a
          href="https://sjlx3.package.qunar.com/user/detail.jsp?id=388551626&rttp=%E6%9C%AC%E5%9C%B0%E6%B8%B8&dep=5YyX5Lqs&arr=6YaJ576O5rW35Y2X&ftdt=2022-12-06%2C2022-12-06&qssrc=eyJ0cyI6IjE2NzAyMjA4MjA4OTIiLCJzcmMiOiJhbGwuZW52YW5vIiwiYWN0Ijoic2VhcmNoIiwicmFuZG9tIjoiNTc5ODQifQ==&ts=1670220821909_654#vid=qb2c_sjlx3&func=6Lef5Zui5ri4&djtf=dj_list_A-B-C_3-sbj_%E6%B5%B7%E6%99%AF%E6%88%BF6_newano%2Cdj_list_A-B-C_9-tts_%E5%93%81%E8%B4%A8%E7%BA%AF%E7%8E%A96_newano%2Cdj_list_A-B-C_9-tts_%E4%BA%B2%E5%AD%90%E4%B9%90%E5%9B%AD6_newano%2Cdj_list_A-B-C_9-tts_%E7%BA%AF%E7%8E%A9%E5%B0%8F%E5%9B%A26_newano%2Cdj_list_A-B-C_9-tts_%E6%97%85%E8%A1%8C%E6%96%B0%E5%BD%A2%E5%BC%8F6_newano%2Cdj_list_A-B-C_9-tts_%E9%AB%98%E6%A1%A3%E5%9E%8B%E9%85%92%E5%BA%976_newano&tm=l01_all_search_newano&pid=388551626&rid=75209920&vd=5Zu95peF"
          class="line"
        >
          <div class="line-lf">
            <img
              src="https://source.qunarzz.com/site/images/wns/20221203-shijianchen-line2.png"
              alt=""
            />
          </div>
          <div class="line-rt">
            <div class="line-tit text-overflow">
              醉美海南☀5星海景房☀纯玩无购物☀帆船出海☀亚特兰蒂斯水世界☀海南三亚5日游
            </div>
            <div class="line-btm">
              <span class="price">1880<i>起/人</i></span>
              <span class="go">马上出发</span>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="box5">
      <div class="content">
        <!-- <img
          src="https://source.qunarzz.com/site/images/wns/20221203-shijianchen-online.png"
          alt=""
        /> -->
        <div style="position:relative;z-index:1;">
          <img
            src="https://source.qunarzz.com/site/images/wns/20230206-shijianchen-online.jpg"
            alt=""
          />
          <span class="btn1 btn2"><span>点击了解更多</span></span>
        </div>
        <gotomini></gotomini>
      </div>
    </div>
    <img
      class="btmimg"
      src="https://source.qunarzz.com/site/images/wns/20221203-shijianchen-btmimg.png"
      alt=""
    />
    <a
      href="http://www.lianhuaqingwen.com/"
      class="btn1 btn2 btn3"
      v-maidian="'home'"
      >点击进入官网</a
    >
  </div>
</template>
<script>
import banner from './components/banner.vue';
import lineComp from './components/line.vue';
import loginDialog from '@/components/login/index';
import videoComp from './components/videoComp.vue';
import shareDialog from './components/dialog/share/index';
import { shareToPlatform } from '@/utils/hybird';
import giftDialog from './components/dialog/gift/index';
import gotomini from './components/gotomini.vue';
import moment from 'moment';
export default {
  components: {
    banner,
    lineComp,
    videoComp,
    gotomini,
  },
  data() {
    return {
      nums: [0, 0],
      days: 0,
      type: '',
      voteList: [
        {
          poster:
            'https://source.qunarzz.com/site/images/wns/20221226-shijianchen-lianposter2.jpg',
          video:
            'https://source.qunarzz.com/site/images/wns/20221223-shijianchen-lian-video.mp4',
          link: 'http://travel.qunar.com/travelbook/note/7761879',
          note: {
            logo: 'https://source.qunarzz.com/site/images/wns/20221223-shijianchen-snow-1.jpg',
            img: 'https://source.qunarzz.com/site/images/wns/20221223-shijianchen-snow-2.jpg',
            nickName: 'Crystal-塔晓佳',
            content: '去澳门吧，不用出国也能体会到各式异域风情的绝佳目的地！',
          },
        },
        {
          poster:
            'https://source.qunarzz.com/site/images/wns/20221229-shijianchen-lian-poster.png',
          video:
            'https://source.qunarzz.com/site/images/wns/20221229-shijianchen-note.mp4',
          link: 'https://travel.qunar.com/travelbook/note/7761979#',
          note: {
            logo: 'https://source.qunarzz.com/site/images/wns/20221229-shijianchen-lian-1.png',
            img: 'https://source.qunarzz.com/site/images/wns/20221229-shijianchen-lian-2.png',
            nickName: 'corain君',
            content: '温馨回家路：挑年货，备好礼，感受老上海的别样年味',
          },
        },
        {
          poster:
            'https://source.qunarzz.com/site/images/wns/20221222-shijianchen-poster.jpg',
          video:
            'https://source.qunarzz.com/site/images/wns/20221222-shijianchen-video.mp4',
          link: 'http://travel.qunar.com/travelbook/note/7761627',
          note: {
            logo: 'https://source.qunarzz.com/site/images/wns/20221222-shijianchen-logo.jpg',
            img: 'https://source.qunarzz.com/site/images/wns/20221222-shijianchen-poster.jpg',
            nickName: '游走旅行的摄影人',
            content: '绍兴48小时，追寻鲁迅先生笔下的“江南鲁镇”',
          },
        },
      ],
      imgList: [
        'https://source.qunarzz.com/site/images/wns/20230324-shijianchen-img1.jpg',
        // 'https://source.qunarzz.com/site/images/wns/20230224-shijianchen-dali.jpg',
        // 'https://source.qunarzz.com/site/images/wns/20230224-shijianchen-qingdao.jpg',
        // 'https://source.qunarzz.com/site/images/wns/20230224-shijianchen-anshan.png',
        // 'https://source.qunarzz.com/site/images/wns/20230224-shijianchen-foshan2.jpeg',
      ],
      linkList: [
        {
          link: 'https://m.flight.qunar.com/shark/active/0edfe48b0b6e5e5bc40a0fd8ca586504',
          text: '青岛市北区',
        },
        // {
        //   link: 'https://m.flight.qunar.com/shark/active/552676a181adaff8fb5d0fbd2c659c63',
        //   text: '云南大理',
        // },
        // {
        //   link: 'https://m.flight.qunar.com/shark/active/543e686cd7cbfa480a39d10a3ea59d81',
        //   text: '青岛市南区',
        // },
        // {
        //   link: 'https://m.flight.qunar.com/shark/active/275d7aebd3c9a947fdda623012b9cba7',
        //   text: '鞍山补贴',
        // },
        // {
        //   link: 'https://m.flight.qunar.com/shark/active/92560a618fc7968d26a8ec849f5c646b',
        //   text: '佛山银联',
        // }
      ],
    };
  },
  methods: {
    jumpTo(item) {
      window.location.href = item.link;
    },
    jumpFlight() {
      location.href = 'https://m.flight.qunar.com/h5/flight/';
    },
    jumpLink(href) {
      location.href = href;
    },
    jumpTrain() {
      location.href =
        'https://touch.train.qunar.com/train_touch/index.html#/?from=touchindex&bd_source=&ouid=';
    },
    prev: function () {
      this.$refs.swipeWrapper.prev();
    },
    next: function () {
      this.$refs.swipeWrapper.next();
    },
  },
  created() {
    let days = moment('2023/01/08 00:00:00').diff(moment(), 'days');
    this.days = days;
    let str = days < 10 ? '0' + days : '' + days;
    this.nums = [str[0], str[1]];
    this.type = this.$route.query.type || '';
  },
  mounted() {
    new Swiper('.lianhuaqingwen .swiper-container', {
      // loop: true, // 循环模式选项
      autoplay: {
        delay: 3000, //1秒切换一次
      },
      pagination: {
        el: '.lianhuaqingwen .swiper-pagination',
      },
    });
  },
};
</script>
<style lang='less' scoped='true'>
#main {
  background: url(https://source.qunarzz.com/site/images/wns/20230206-shijianchen-banner.png)
    no-repeat;
  background-size: 100% auto;
  padding-left: 10px;
  padding-right: 10px;
  box-sizing: border-box;
  background-color: #3ca28c;
  overflow-x: hidden;
  padding-bottom: 20px;
}
.top {
  height: 438px;
  overflow: hidden;
}
.box1 {
  overflow: hidden;
  .content {
    background: url(https://source.qunarzz.com/site/images/wns/20221212-shijianchen-lianhua-1.png)
      no-repeat;
    background-size: 100% 100%;
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    box-sizing: border-box;
  }
  &:before {
    content: '';
    display: block;
    background: url(https://source.qunarzz.com/site/images/wns/20230206-shijianchen-lian-7.png)
      no-repeat;
    background-size: 100% auto;
    height: 105px;
  }
  &:after {
    content: '';
    display: block;
    background: url(https://source.qunarzz.com/site/images/wns/20230206-shijianchen-lian-1.png)
      no-repeat;
    background-size: 100% auto;
    height: 40px;
    background-position-y: -372px;
    position: relative;
    top: -1px;
  }
}
.prev-button {
  background: url(https://picbed.qunarzz.com/0522869ca923f0a252e0a46c5419424a.png)
    no-repeat;
  background-size: 95% auto;
  width: 23px;
  height: 29px;
  position: absolute;
  top: 70px;
  left: 0;
  z-index: 999;
}
.swipe {
  width: 315px;
  height: 320px;
  margin: 0 auto;
  .swiper-pagination {
    bottom: 0;
  }
  .img-box {
    height: 250px;
    overflow-y: hidden;
    img{
      min-height: 250px;
    }
  }
  img {
    width: 315px;
  }
}
.next-button {
  background: url(https://picbed.qunarzz.com/c9a2ebcdcaefb77c20ffd077b3965be7.png)
    no-repeat;
  background-size: 95% auto;
  width: 23px;
  height: 29px;
  position: absolute;
  top: 70px;
  right: 0;
  z-index: 999;
}
.box2 {
  &:before {
    content: '';
    display: block;
    background: url(https://source.qunarzz.com/site/images/wns/20230206-shijianchen-lian-1.png)
      no-repeat;
    background-size: 100% auto;
    height: 110px;
  }
  .content {
    height: 320px;
    width: 100%;
    background: url(https://source.qunarzz.com/site/images/wns/20221212-shijianchen-lianhua-1.png)
      no-repeat;
    background-size: 100% 100%;
    position: relative;
    top: -1px;
  }
  &:after {
    content: '';
    display: block;
    background: url(https://source.qunarzz.com/site/images/wns/20230206-shijianchen-lian-1.png)
      no-repeat;
    background-size: 100% auto;
    height: 40px;
    background-position-y: -391px;
    position: relative;
    top: -2px;
  }
  /deep/ .mint-swipe-indicators {
    bottom: 0;
  }
}
.box3 {
  overflow: hidden;
  &:before {
    content: '';
    display: block;
    background: url(https://source.qunarzz.com/site/images/wns/20230206-shijianchen-lian-2.png)
      no-repeat;
    background-size: 100% auto;
    height: 100px;
    overflow: hidden;
  }
  .content {
    background: url(https://source.qunarzz.com/site/images/wns/20221205-shijianchen-box3-2.png);
    background-size: 100% 100%;
    overflow: hidden;
    padding-left: 18px;
    padding-right: 18px;
    position: relative;
    top: -1px;
  }
  .text2 {
    width: 205px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
  }
  &:after {
    content: '';
    display: block;
    background: url(https://source.qunarzz.com/site/images/wns/20221205-shijianchen-box3-3.png)
      no-repeat;
    background-size: 100% auto;
    height: 50px;
    overflow: hidden;
    position: relative;
    top: -2px;
  }
}
.box6 {
  background: url(https://source.qunarzz.com/site/images/wns/20230206-shijianchen-lian-4.png)
    no-repeat;
  background-size: 100% auto;
  height: 490px;
  overflow: hidden;
  .content {
    height: 368px;
    width: 320px;
    margin: 0 auto;
    margin-top: 103px;
    overflow: hidden;
  }
}
.box4 {
  background: url(https://source.qunarzz.com/site/images/wns/20230206-shijianchen-lian-5.png)
    no-repeat;
  background-size: 100% auto;
  height: 473px;
  overflow: hidden;
  .content {
    height: 320px;
    width: 320px;
    margin: 0 auto;
    margin-top: 103px;
  }
}
.box7 {
  background: url(https://source.qunarzz.com/site/images/wns/20230206-shijianchen-lian-3.png)
    no-repeat;
  background-size: 100% 100%;
  height: 335px;
  overflow: hidden;
  .content {
    height: 320px;
    width: 320px;
    margin: 0 auto;
    margin-top: 90px;
  }
}
.box5 {
  background: url(https://source.qunarzz.com/site/images/wns/20230206-shijianchen-lian-6.png)
    no-repeat;
  background-size: 100% auto;
  height: 401px;
  overflow: hidden;
  .content {
    height: 270px;
    width: 320px;
    margin: 0 auto;
    margin-top: 103px;
  }
}
.btn1 {
  background: url(https://source.qunarzz.com/site/images/wns/20230206-shijianchen-btn.png)
    no-repeat;
  background-size: 100% auto;
  width: 180px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 18px auto 0;
  color: #fff;
  cursor: pointer;
  position: relative;
  z-index: 50;
  span {
    position: relative;
    top: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    .arr {
      width: 4px;
      margin-left: 8px;
    }
  }
}
.swipe-wrapper {
  height: 100%;
  width: 320px;
  margin: 0 auto;
}
.note {
  display: flex;
  height: 80px;
  border-radius: 5px;
  overflow: hidden;
  justify-content: space-between;
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 10px;
  .note-lf {
    img {
      height: 80px;
      border-radius: 5px;
    }
  }
  .note-rt {
    width: calc(100% - 148px);
    padding: 6px 12px 8px;
    border-radius: 5px;
    background-color: #000000;
  }
  .note-nick {
    display: flex;
    align-items: center;
    color: #fff;
  }
  .note-cont {
    text-align: left;
    color: #868686;
    font-size: 10px;
    margin-top: 3px;
  }
  .logo {
    width: 30px;
    border-radius: 50%;
    margin-right: 5px;
  }
}
.text {
  border: 3px solid #fb613e;
  .tp {
    /* 距离春节购票还有 */
    font-size: 18px;
    font-weight: bold;
    color: #f12b19;
    display: flex;
    align-items: center;
    padding-top: 10px;
    padding-bottom: 10px;
    justify-content: center;
    background: url(https://source.qunarzz.com/site/images/wns/2021206-shijianchen-lianhua-bg.png)
      no-repeat;
    background-size: 100% 100%;
  }
  .btm {
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 3px solid #f12b19;
    color: #f12b19;
    font-size: 32px;
    font-weight: bold;
    padding-top: 10px;
    padding-bottom: 10px;
    background: url(https://source.qunarzz.com/site/images/wns/2021206-shijianchen-lianhua-bg.png)
      no-repeat;
    background-size: 100% 100%;
    .str {
      display: block;
      padding-left: 3px;
      padding-right: 3px;
      height: 40px;
      background-color: #f12b19;
      color: #fff;
      display: flex;
      align-items: center;
      margin-left: 8px;
      justify-content: center;
      &:last-child {
        margin-right: 8px;
      }
    }
  }
}
.box {
  background: url(https://source.qunarzz.com/site/images/wns/20221203-shijianchen-ticket-1.png)
    no-repeat;
  background-size: 100% auto;
}
.boxBoth {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  img {
    width: calc(50% - 5px);
    height: 128px;
  }
}
.box6-txt {
  text-align: left;
  font-size: 13px;
  overflow-y: auto;
  height: 160px;
}
.content {
  overflow: hidden;
  position: relative;
}
.line {
  display: flex;
  height: 123px;
  margin-top: 15px;
  &:last-child {
    margin-top: 45px;
  }
  .line-lf {
    width: 115px;
    img {
      height: 123px;
    }
  }
  .line-rt {
    width: calc(100% - 115px);
    box-sizing: border-box;
    padding: 0 10px;
    height: 123px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .line-btm {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .price {
    background-color: #f9ecec;
    padding: 4px 6px;
    font-size: 19px;
    color: #f12b19;
    font-weight: bold;
    i {
      font-size: 12px;
      font-style: normal;
      color: #3d3d3d;
    }
  }
  .go {
    border: 1px solid;
    background-color: #f12b19;
    border-image: linear-gradient(
      180deg,
      #f1ddb9 4%,
      #d8935a 41%,
      #f8e2c1 70%,
      #d4864a 98%
    );
    padding: 6px 12px;
    color: #ffebd5;
    border-radius: 6px;
  }
}
.btmimg {
  width: 215px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
}
.btmimgbtn {
  width: 270px;
  margin: 0 auto;
  margin-bottom: 40px;
}
.btn2 {
  width: 250px;
  height: 36px;
  background: linear-gradient(180deg, #82d3ff 4%, #4ab8f3 37%, #266ec4 91%);
  border-radius: 32px;
  span {
    top: 0;
  }
}
.btn3 {
  margin-top: 0;
}
</style>